var _effectorFileName = "/src/shared/components/modal/modal.tsx";
import { useState } from 'react';
import { useTranslation } from 'next-i18next';
import { EntryPoint } from '@/shared/components/contact-form/types';
import CheckMarkIcon from '@/shared/components/icons/checkmark-icon';
import { TextGradient } from '@/shared/components/text-gradient';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '@/shared/components/ui/dialog';
interface ModalProps {
  dialogTrigger?: React.ReactNode;
  children: React.ReactNode;
  isModalSentSuccessfully: boolean;
  entryPoint: EntryPoint;
  title: string;
  description?: string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  onModalClosed: () => void;
}
export const Modal = (props: ModalProps) => {
  const {
    dialogTrigger,
    children,
    title,
    description,
    isModalSentSuccessfully,
    open: controlledOpen,
    onOpenChange,
    onModalClosed
  } = props;
  const {
    t
  } = useTranslation('common');
  const isControlled = controlledOpen !== undefined;
  const [uncontrolledOpen, setUncontrolledOpen] = useState(false);
  const open = isControlled ? controlledOpen : uncontrolledOpen;
  const handleOpenChange = (isOpen: boolean) => {
    if (!isControlled) {
      setUncontrolledOpen(isOpen);
    }
    onOpenChange?.(isOpen);
    if (!isOpen) {
      onModalClosed();
    }
  };
  return <Dialog open={open} onOpenChange={handleOpenChange}>
      {dialogTrigger ? <DialogTrigger asChild>{dialogTrigger}</DialogTrigger> : null}

      <DialogContent className="max-w-[90%] rounded-md bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 sm:max-w-[425px]">
        {!isModalSentSuccessfully && <>
            <DialogHeader>
              <DialogTitle>{title}</DialogTitle>
              {description && <DialogDescription>{description}</DialogDescription>}
            </DialogHeader>

            {children}
          </>}

        {isModalSentSuccessfully && <>
            <DialogHeader className="sr-only">
              <DialogTitle className="sr-only">{t('modal.successTitle')}</DialogTitle>
              <DialogDescription className="sr-only">{t('modal.successDescription')}</DialogDescription>
            </DialogHeader>

            <div className="flex h-full flex-col items-center justify-center">
              <CheckMarkIcon className="mb-4 h-10 w-10 shrink-0 rounded-full bg-brand-accent-light p-[2px] text-white dark:bg-brand-accent-normal" />

              <div className="text-center">
                <TextGradient text={t('modal.successTitle')} className="mb-1 header-h1" />
                <p className="text-muted-foreground">{t('modal.successDescription')}</p>
              </div>
            </div>
          </>}
      </DialogContent>
    </Dialog>;
};